import React, { useContext, useState } from 'react'
import { Auth } from 'aws-amplify'
import { Input, Link, Text } from '@/style-guide'
import { Button, Form } from 'antd'
import { AuthContext } from '../AuthContext'

export const ForgotPassword = () => {
  const { setStep, setPayload } = useContext(AuthContext)
  const [isLoading, setLoading] = useState(false)
  const [form] = Form.useForm()

  const submit = async (values) => {
    setLoading(true)
    const payload = {
      email: values.email.toLowerCase(),
      type: 'ForgotPassword',
    }
    setPayload(payload)
    try {
      await Auth.forgotPassword(payload.email)
      setStep('reset-password')
    } catch (error) {
      if (error && error.code === 'LimitExceededException') {
        form.setFields([{ name: 'email', errors: [error.message] }])
      } else {
        try {
          await Auth.resendSignUp(payload.email)
          setStep('reset-password')
        } catch (err) {
          form.setFields([
            { name: 'email', errors: ['The email submitted does not exist'] },
          ])
        }
      }
    } finally {
      setLoading(false)
    }
  }

  const openContactUsEmail = () => {
    window.location.href = 'mailto:hello@tripsha.com'
  }

  return (
    <>
      <Form
        form={form}
        onFinish={submit}
        scrollToFirstError
        initialValues={{ email: '' }}
      >
        <Form.Item
          name="email"
          rules={[
            { required: true, message: 'Please input your email.' },
            {
              type: 'email',
              message: 'The input is not valid email!',
            },
          ]}
        >
          <Input label="Email address" name="email" />
        </Form.Item>
        <Form.Item>
          <Button
            block
            loading={isLoading}
            htmlType="submit"
            type="primary"
            size="large"
            style={{ height: '60px' }}
          >
            Reset password
          </Button>
        </Form.Item>
      </Form>
      <div className="footer">
        <Text size={16}>
          Still not working?{' '}
          <Link
            label="Contact us"
            primary
            size={16}
            onClick={openContactUsEmail}
          />
        </Text>
        <Text size={16}>
          Back to{' '}
          <Text className="link-text" onClick={() => setStep('login')}>
            Login
          </Text>
        </Text>
      </div>
    </>
  )
}
